import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-auction-configuration',
  templateUrl: './manage-auction-configuration.component.html',
  styleUrls: ['./manage-auction-configuration.component.css']
})
export class ManageAuctionConfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/manage-auction-configuration/manage-auction-configuration.component.ts